/* tslint:disable */
import {
  FundsBudgeted,
  Institutions
} from '../index';

declare var Object: any;
export interface BudgetBreakdownItemInterface {
  "amount": number;
  "financial_year": string;
  "description": string;
  "institution_id": number;
  "funds_budgeted_id": number;
  "id"?: number;
  funds_budgeted?: FundsBudgeted;
  institutions?: Institutions;
}

export class BudgetBreakdownItem implements BudgetBreakdownItemInterface {
  "amount": number;
  "financial_year": string;
  "description": string;
  "institution_id": number;
  "funds_budgeted_id": number;
  "id": number;
  funds_budgeted: FundsBudgeted;
  institutions: Institutions;
  constructor(data?: BudgetBreakdownItemInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `BudgetBreakdownItem`.
   */
  public static getModelName() {
    return "BudgetBreakdownItem";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of BudgetBreakdownItem for dynamic purposes.
  **/
  public static factory(data: BudgetBreakdownItemInterface): BudgetBreakdownItem{
    return new BudgetBreakdownItem(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'BudgetBreakdownItem',
      plural: 'BudgetBreakdownItems',
      path: 'BudgetBreakdownItems',
      properties: {
        "amount": {
          name: 'amount',
          type: 'number'
        },
        "financial_year": {
          name: 'financial_year',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "institution_id": {
          name: 'institution_id',
          type: 'number'
        },
        "funds_budgeted_id": {
          name: 'funds_budgeted_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        funds_budgeted: {
          name: 'funds_budgeted',
          type: 'FundsBudgeted',
          model: 'FundsBudgeted'
        },
        institutions: {
          name: 'institutions',
          type: 'Institutions',
          model: 'Institutions'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/BudgetBreakdownItem.ts